__turbopack_context__.v({
  "action": "Content-module-scss-module__I1aNZa__action",
  "content": "Content-module-scss-module__I1aNZa__content",
});
